import { createContext, useContext, useState } from "react";
import type { ReactNode } from "react";
interface HeaderButtonContextType {
  Comp: ReactNode | null;
  setComp: (comp: ReactNode | null) => void;
}

const HeaderButtonContext = createContext<HeaderButtonContextType | undefined>(
  undefined,
);

export function HeaderButtonProvider({ children }: { children: ReactNode }) {
  const [Comp, setComp] = useState<ReactNode | null>(null);
  return (
    <HeaderButtonContext.Provider value={{ Comp, setComp }}>
      {children}
    </HeaderButtonContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useHeaderButton() {
  const context = useContext(HeaderButtonContext);
  if (context === undefined) {
    throw new Error(
      "useHeaderButton must be used within a HeaderButtonProvider",
    );
  }
  return context;
}
